import { render, staticRenderFns } from "./BaseLoadingPage.vue?vue&type=template&id=7f88c45e"
import script from "./BaseLoadingPage.vue?vue&type=script&lang=js"
export * from "./BaseLoadingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports